module.exports = __webpack_public_path__ + "static/media/value.d945209b.svg";